import React from 'react';
import styles from './order.module.scss';
import { KoText, KoTitle } from 'packages';
import KoIcon from '@kwapio/icons';

const chartConfigs = [
  {
    id: 'placed',
    label: 'Placed',
    icon: 'PlacedOutlined',
    arrow: 'ArrowLineUpFilled',
    description: '+125 today',
    value: `$77,000`
  },
  {
    id: 'processing',
    label: 'Processing',
    icon: 'ProcessingOutlined',
    color:"#FE9431",
    arrow: 'ArrowLineUpFilled',
    description: '+125 today',
    value: `$75,000`
  },
  {
    id: 'shipping',
    label: 'Shipping',
    icon: 'OrderShippingOutlined',
    arrow: 'ArrowLineUpFilled',
    description: '+0 today',
    value: `$73,000`
  },
  {
    id: 'success',
    label: 'Success',
    icon: 'PublishedOutlined',
    arrow: 'ArrowLineDownFilled',
    description: '10 today',
    value: `$80,000`
  }
];


export default function OrderStatus() {

  return (
    <div className={styles.statusWrapper}>
      {chartConfigs.map(({ id, description , icon, arrow, label, value,color}) => (
        <div key={id} className={styles.card}>
          <div className={styles.header}>
            <KoIcon name={icon} width={25} height={25} color={color?color:"#707A8F"}/>
            <KoText className={styles.label} text={label} />
          </div>
          <div className={styles.mycontent} >
            <div className={styles.count}>
              <KoTitle level={1} className={styles.value} text={value} />
            </div></div>
          <div className={styles.mycontent} >
            <div className={styles.count}>
              <div className={styles.descriptionBox}>
                <KoText className={arrow ==='ArrowLineUpFilled' ?  styles.success : styles.budget} text='10%' />
                <KoIcon name={arrow} width={16} height={16} />
                <KoText className={styles.description} text={description} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}